import { createStore, applyMiddleware } from 'redux';
import thunk from 'redux-thunk';
import rootReducer from './modules/reducers';

const enhancer = applyMiddleware(thunk);

function configureStore(/* initialState */) {
  const store = createStore(rootReducer, enhancer);

  return { store };
}

export default configureStore;



// WEBPACK FOOTER //
// ./src/redux/create-store.js